import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';

const backendNotifications = (state = {
    items: [],
    loaded: false,
}, action) => {
    switch (action.type) {
        case actionTypes.CREATE_BACKEND_NOTIFICATION.REQUEST: {
            return {
                ...state,
            };
        }
        case actionTypes.CREATE_BACKEND_NOTIFICATION.SUCCESS: {
            return {
                ...state,
                items: [ ...state.items, ...action.data ],
            };
        }
        case actionTypes.CREATE_BACKEND_NOTIFICATION.FAILURE: {
            return {
                ...state,
            };
        }

        case actionTypes.GET_BACKEND_NOTIFICATIONS.REQUEST: {
            return {
                ...state,
                loaded: false,
            };
        }
        case actionTypes.GET_BACKEND_NOTIFICATIONS.SUCCESS: {
            return {
                ...state,
                items: action.data,
                loaded: true,
            };
        }
        case actionTypes.GET_BACKEND_NOTIFICATIONS.FAILURE: {
            return {
                ...state,
                loaded: true,
            };
        }

        case actionTypes.GET_BACKEND_NOTIFICATION.REQUEST: {
            return {
                ...state,
            };
        }
        case actionTypes.GET_BACKEND_NOTIFICATION.SUCCESS: {
            return {
                ...state,
                items: [ ...state.items, ...action.data ],
            };
        }
        case actionTypes.GET_BACKEND_NOTIFICATION.FAILURE: {
            return {
                ...state,
            };
        }

        case actionTypes.UPDATE_BACKEND_NOTIFICATION.REQUEST: {
            return {
                ...state,
            };
        }
        case actionTypes.UPDATE_BACKEND_NOTIFICATION.SUCCESS: {

            return {
                ...state,
                items: state.items.map((item) => {
                    if (item._id === action.data._id) {
                        return action.data;
                    }

                    return item;
                })
            };
        }
        case actionTypes.UPDATE_BACKEND_NOTIFICATION.FAILURE: {
            return {
                ...state,
            };
        }

        case actionTypes.DELETE_BACKEND_NOTIFICATION.REQUEST: {
            return {
                ...state,
            };
        }
        case actionTypes.DELETE_BACKEND_NOTIFICATION.SUCCESS: {
            return {
                ...state,
                items: state.items.filter((item) => {
                    return item._id !== action.data;
                })
            };
        }
        case actionTypes.DELETE_BACKEND_NOTIFICATION.FAILURE: {
            return {
                ...state,
            };
        }

        default:
            return state;
    }
};

export default backendNotifications;



// WEBPACK FOOTER //
// ./app/reducers/notifications/backendNotifications.js